export default{
    namespaced:true,
    state: {
        token:''
    },
    getters: {
    },
    mutations: {
        SET_TOKEN: (state, token) => {
  
            state.token = token
        },
        CLEAR_TOKEN: (state) => {
  
            state.token = ''
             console.log('CLEAR_TOKEN')
        },
    },
    actions: {
    },
}